import { put, takeEvery, call, all } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import jsPDF from "jspdf";
import "jspdf-autotable";
var dateFormat = require("dateformat");
var btoa = require("Base64").btoa;

function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
    }
  } catch (err) {
    console.error("error", err);
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* fetchOpLocData(value) {
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    let page = (value.params && value.params.page) || 1;
    let search = (value.params && value.params.search) || "";

    let params = {
      page: page,
      api: `${appConfig.ip}/runnerOperatingLoc?isActive=true&limit=10&page=${page}&runnerId=${user.id}&ser=${search}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_RUNNER_OPERATING_LOCATION_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_RUNNER_OPERATING_LOCATION_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* createOperatingLocation(value) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    let data = {
      countryId: user.country,
      addr: value.params.addr1,
      geoLocation: [value.params.geo[1], value.params.geo[0]],
      radius: value.params.radius.toFixed(),
      runnerId: user.id,
    };
    let params = {
      api: `${appConfig.ip}/runnerOperatingLoc`,
      method: "POST",
      sucessAction: actionTypes.ADD_RUNNER_OPERATING_LOCATION_SUCCESS_ACTION,
      failAction: actionTypes.ADD_RUNNER_OPERATING_LOCATION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);
    yield toast.success("Operating location added successfully", {
      autoClose: 3000,
      className:"toastClass"
    });
    let payload = { payload: { page: 1 }, params: { id: null } };
    yield call(fetchOpLocData, payload);
  } catch (e) {
    console.error(e);
  }
}

function* updateOperatingLocation(value) {
  let data = {
    isActive: value.params.data.isActive,
    countryId: value.params.data.countryId.id,
    user: value.params.data.user.id,
    runnerId: value.params.data.runnerId,
    geoLocation: [
      value.params.data.geoLocation[1],
      value.params.data.geoLocation[0],
    ],
    addr: value.params.data.addr,
    radius: value.params.data.radius.toFixed(),
  };

  try {
    let params = {
      api: `${appConfig.ip}/runnerOperatingLoc/${value.params.data.id}`,
      method: "PUT",
      sucessAction: actionTypes.DELETE_RUNNER_OPERATING_LOCATION_SUCCESS_ACTION,
      failAction: actionTypes.DELETE_RUNNER_OPERATING_LOCATION_FAIL_ACTION,
      body: JSON.stringify(data),
    };
    yield call(commonFunction, params);

    if (value.params.delete) {
      yield toast.success("Operating location deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    } else {
      yield toast.success("Operating location updated successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }

    let payload = { payload: { page: 1 }, params: { id: null } };
    yield call(fetchOpLocData, payload);
  } catch (e) {
    console.error(e);
  }
}

export function* OpertnLocationActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_RUNNER_OPERATING_LOCATION_ACTION,
    fetchOpLocData
  );
  yield takeEvery(
    actionTypes.ADD_RUNNER_OPERATING_LOCATION_ACTION,
    createOperatingLocation
  );

  yield takeEvery(
    actionTypes.DELETE_RUNNER_OPERATING_LOCATION_ACTION,
    updateOperatingLocation
  );
}
